// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"859209ec","823":"64cc72c0"}[chunkId] + ".chunk.js";
};